import {Injectable} from '@angular/core';
import {BaseDao} from '../../../../base-dao';
import {MarketplaceProductFAQ} from '../../../../models';
import {KluhManagerValidator} from '../../../../validators/kluh-manager-validator';
import {Observable} from 'rxjs/internal/Observable';
import {R2CloudHttpApiService} from '../../../../r2-cloud-http-api.service';

@Injectable()
export class MarketplaceProductFAQDaoService extends BaseDao<MarketplaceProductFAQ> {
    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'marketplace-product-faq');
    }

    findAllByMarketplaceProductId(marketplaceProductId: number): Observable<MarketplaceProductFAQ[]> {
        return this.http.get<MarketplaceProductFAQ[]>(this.url + '/find-all-by-marketplace-product-id/' + marketplaceProductId);
    }
}
